import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  RejectRequirement,
  getRequirements,
  updateRequirement,
  modifydetails,
  getAllHostels,
  getHostelWiseRequirements,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Modal, Button, Typography } from "@mui/material";
import axios from "../api/constant";

const RequirementsReport = ({ role, mainId }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rejectReasonError, setRejectReasonError] = useState(false); // Change initial state to false
  const [districtDropdown, setDistrictDropdown] = useState("");
  const [Alldistricts, setAllDistricts] = useState([]);
  const [SchoolDropdown, setSchoolDropdown] = useState("");
  const [AllSchoolName, setAllSchoolName] = useState([]);

  const getAllrequirements = async (hostelName) => {
    setIsLoading(true);
    const HostelID = hostelName ? hostelName : "all";
    try {
      const res = await getHostelWiseRequirements({ hostel_id: HostelID });
      if (res.status === "success") {
        console.log(res);
        setFilteredData(res.data);
      } else {
        toast.error(t("Something went wrong"));
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error(t("Something went wrong"));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    axios
      .get("/get_all_districts")
      .then((response) => {
        if (response.data.status == "success") {
          setAllDistricts(response.data.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`/get_school_name_district_wise?district_code=${districtDropdown}`)
      .then((response) => {
        if (response.data.status == "success") {
          setAllSchoolName(response.data.data);
        } else {
          setAllSchoolName([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, [districtDropdown]);

  useEffect(() => {
    setIsLoading(true);
    if (districtDropdown && SchoolDropdown) {
      axios
        .get(
          `/get_school_requirement_report?district_code=${districtDropdown}&UDISE_code=${SchoolDropdown}`
        )
        .then((response) => {
          if (response.data.status == "success") {
            setFilteredData(response.data.data);
            setRows(response.data.data);
            setIsLoading(false);
          } else {
            setFilteredData([]);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  }, [districtDropdown, SchoolDropdown]);

  // Update filteredData whenever searchQuery changes
  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        item.gp_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.amenities_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.amenities_sub_type_name
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (item.actual_count &&
          item.actual_count
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.ideal_count &&
          item.ideal_count
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.shortage_count &&
          item.shortage_count
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase()))
    );
    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
  };
  const handleUpdateClick = (row) => {
    setSelectedRow(row);
    console.log("selectedRow", selectedRow);
    setModalOpen(true);
  };
  const handlerejectClick = (row) => {
    setSelectedRow(row);
    console.log("selectedRow", selectedRow);

    setModalOpen1(true);
  };

  const handleCloseModal = () => {
    // Logic to close modal
    setShowRejectReason(false);
    setModalOpen(false);
  };
  const handleCloseModal1 = () => {
    // Logic to close modal
    setShowRejectReason(false);
    setModalOpen1(false);
  };
  const handlesave = (selectedRow) => {
    const postData = {
      requirement_name: selectedRow.requirement_name,
      quantity: selectedRow.quantity,
      hostel_id: selectedRow.id,
      user_id: "",
      role_id: "",
      requirement_id: selectedRow.requirement_id,
    };

    modifydetails(postData)
      .then((response) => {
        setModalOpen(false);
        getAllrequirements();
        toast.success(response.message);
      })
      .catch((error) => {
        console.error("Error updating requirement:", error);
        toast.error(error.response.data.message);
      });
  };

  const handleRejectWithReason = () => {
    setShowRejectReason(true);
    if (rejectReason.trim() === "") {
      setRejectReasonError(true); // Show error message if reject reason is empty
      return;
    }

    const postData = {
      hostel_id: selectedRow.id,
      requirement_id: selectedRow.requirement_id,
      is_reject: true, // Set to true to indicate rejection
      remarks: rejectReason, // Pass the reject reason
    };

    RejectRequirement(postData)
      .then((response) => {
        setModalOpen1(false);
        getAllrequirements();
        toast.success(response.message || "Update successful");
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const HostelNamehandel = async (e) => {
    // setExistAssetsSubTypes(e.target.value);
    const hostelName = e.target.value;

    getAllrequirements(hostelName);
  };

  const handleSelectDistrict = async (e) => {
    setDistrictDropdown(e.target.value);
  };

  const handleSelectSchool = async (e) => {
    setSchoolDropdown(e.target.value);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("School Requirements")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="col-md-2 mt-1" style={{ marginRight: "6px" }}>
            <label htmlfor="title">{t("Academic Year")}</label>
            <select
              name="district" // value={AssetsType}
              className="common-input form-select"
            >
              <option value="" selected={true}>
                {t("2023-24")}
              </option>
            </select>
          </div>
          <div className="col-md-2 mt-1" style={{ marginRight: "6px" }}>
            <label htmlfor="title">{t("District")}</label>
            <select
              name="district" // value={AssetsType}
              className="common-input form-select"
              onChange={handleSelectDistrict}
            >
              <option value="" selected={true}>
                {t("Select District")}
              </option>
              {Alldistricts &&
                Alldistricts.map((row) => (
                  <option key={row.district_code} value={row.district_code}>
                    {" "}
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-2" style={{ marginRight: "6px" }}>
            <label htmlfor="title">{t("School Name")}</label>
            <select
              name="school_name" // value={AssetsType}
              className="common-input form-select"
              onChange={handleSelectSchool}
            >
              <option value="all" selected={true}>
                {t("Select School Name")}
              </option>
              {AllSchoolName &&
                AllSchoolName.map((row) => (
                  <option key={row.UDISE_code} value={row.UDISE_code}>
                    {" "}
                    {row.school_name}
                  </option>
                ))}
            </select>
          </div>
          {/* <div className="">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{ marginTop: "37px" }}
            />
          </div> */}
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Block Name")}</TableCell>
                  <TableCell align="left">{t("GP Name")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="left">{t("School Type")}</TableCell>
                  <TableCell align="left">{t("Amenities Type")}</TableCell>
                  <TableCell align="left">
                    {t("Amenities Sub Type Name")}
                  </TableCell>
                  <TableCell align="left">{t("Actual Count")}</TableCell>
                  <TableCell align="left">{t("Ideal Count")}</TableCell>
                  <TableCell align="left">{t("Shortage Count")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {" "}
                          {index + 1}
                        </TableCell>
                        <TableCell align="left"> {row.block_name} </TableCell>
                        <TableCell align="left">{row.gp_name} </TableCell>
                        <TableCell align="left">{row.school_name}</TableCell>
                        <TableCell align="left">{row.school_type}</TableCell>
                        <TableCell align="left">
                          {" "}
                          {row.amenities_type}
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="left"> {row.actual_count}</TableCell>
                        <TableCell align="left"> {row.ideal_count}</TableCell>
                        <TableCell align="left">
                          {" "}
                          {row.shortage_count}
                        </TableCell>
                        {/* <TableCell align="left" style={{
                          color: (row.is_approve && row.admin_flag && row.is_received) ? 'green' :
                            (row.is_approve && row.admin_flag && !row.is_received) ? 'orange' : 'inherit'
                        }}>
                          {
                            (row.is_approve == 1 && row.admin_flag == 1 && row.is_received == 1) ? 'Completed' :
                              (row.is_approve == 1 && row.admin_flag == 1 && row.is_received != 1) ? 'Not Delivered' :
                                (row.is_approve == 1 && row.admin_flag != 1 && row.is_received != 1) ? 'Pending by Admin' :
                                  ''
                          }
                        </TableCell> */}
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      {/* {selectedRow && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "30%",
              left: "52%",
              transform: "translate(-50%, -50%)",
              maxWidth: "90vw",
              width: "70%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Update Status
            </Typography>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Requirement</label>
                <input
                  type="text"
                  name="requirement"
                  defaultValue={selectedRow.requirement_name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Hostel Name</label>
                <input
                  type="text"
                  name="hostel-name"
                  defaultValue={selectedRow.hostel_name}
                  className="form-control"
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Hostel Address</label>
                <input
                  type="text"
                  name="hostel-address"
                  defaultValue={selectedRow.address}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Quantity</label>
                <input
                  type="text"
                  name="quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      quantity: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
            </div>
            {showRejectReason && (
              <div className="mb-3">
                <label className="form-label">Reason for Rejection</label>
                <input
                  type="text"
                  name="rejectreason"
                  value={rejectReason}
                  className={`form-control ${
                    rejectReasonError ? "border-danger" : ""
                  }`}
                  onChange={(e) => setRejectReason(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.target.value.length >= 5) {
                      setRejectReasonError(false);
                    }
                  }}
                  required
                />
                {rejectReasonError && (
                  <small className="text-danger">
                    Reason for Rejection is required.
                  </small>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={() => handlesave(selectedRow)}
              >
                Save
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {selectedRow && (
        <Modal
          open={modalOpen1}
          onClose={handleCloseModal1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "30%",
              left: "52%",
              transform: "translate(-50%, -50%)",
              maxWidth: "90vw",
              width: "70%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Update Status
            </Typography>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Requirement</label>
                <input
                  type="text"
                  name="requirement"
                  defaultValue={selectedRow.requirement_name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Hostel Name</label>
                <input
                  type="text"
                  name="hostel-name"
                  defaultValue={selectedRow.hostel_name}
                  className="form-control"
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Hostel Address</label>
                <input
                  type="text"
                  name="hostel-address"
                  defaultValue={selectedRow.address}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Quantity</label>
                <input
                  type="text"
                  name="quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      quantity: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
            </div>
            {showRejectReason && (
              <div className="mb-3">
                <label className="form-label">Reason for Rejection</label>
                <input
                  type="text"
                  name="rejectreason"
                  value={rejectReason}
                  className={`form-control ${
                    rejectReasonError ? "border-danger" : ""
                  }`}
                  onChange={(e) => setRejectReason(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.target.value.length >= 5) {
                      setRejectReasonError(false);
                    }
                  }}
                  required
                />
                {rejectReasonError && (
                  <small className="text-danger">
                    Reason for Rejection is required.
                  </small>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={() => handleRejectWithReason(selectedRow)}
              >
                Reject
              </Button>
            </div>
          </div>
        </Modal>
      )} */}
    </>
  );
};

export default RequirementsReport;
